module.exports = __webpack_public_path__ + "img/cell_coupon_img.15e4e5b8.png";